import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import type {
  SupportedCoinDto,
  ExtendedApiResponse,
  SupportedCoinsRequest,
  SupportedCoinsResponse,
} from '@coin-depo-types';

import { StorageService } from '@coin-depo-core/storage';

import { ApiService,} from '@coin-depo/http';
import { AuthService } from '@coin-depo/services';
import { CoinBaseService } from '@coin-depo-core/coin';

@Injectable({
  providedIn: 'root',
})
export class CoinsService extends CoinBaseService {
  protected storageKey = 'supportedCoins';

  protected supportedCoins$ = new BehaviorSubject<SupportedCoinDto[]>(
    this.storage.get(this.storageKey, [])
  );

  override get cachedSupportedCoins$(): Observable<SupportedCoinDto[]> {
    return this.supportedCoins$.asObservable().pipe(
      map(coins =>
        coins
          .filter(c => c.is_active === 1)
          .sort((a, b) => a.order - b.order)
      )
    );
  }

  constructor(
    protected balancesApi: ApiService,
    protected auth: AuthService,
    protected storage: StorageService
  ) {
    super();
  }

  override updateSupportedCoins(): Observable<
    ExtendedApiResponse<SupportedCoinsResponse>
  > {
    const data: SupportedCoinsRequest = {
      client_token: this.auth.accessToken,
      username: this.auth.userData.email,
    };

    return this.balancesApi.getSupportedCoins(data).pipe(
      tap(res => {
        this.supportedCoins$.next(res.coin_list);
        this.storage.set(this.storageKey, res.coin_list);
      })
    );
  }

  getVestingCSV(coin_id: number) {
    return this.balancesApi.getVestingCsv({
      client_token: this.auth.accessToken,
      username: this.auth.userData.email,
      coin_id
    });
  }
}
